module.exports = __webpack_public_path__ + "static/media/main idea.a920ca95.mp3";